document.addEventListener("DOMContentLoaded", function () {
// Shop By Category Slider Js
    const iscustomslider = document.querySelectorAll(
    ".block__custom_swiper-wrap.swiper"
    );

    if (iscustomslider.length > 0) {
    iscustomslider.forEach((shop_category_widget) => {
      const maxProductShow = parseInt(
      shop_category_widget.dataset.maxproductshow,
      10
    );
     console.log(maxProductShow);
        new Swiper(shop_category_widget, {
        slidesPerView: maxProductShow,
        spaceBetween: 15,
        centeredSlides: false,
        loop: false,
        breakpoints: {
            320: {
            slidesPerView: 1.2,
            spaceBetween: 10,
            autoplay:true,
            },
            768: {
            slidesPerView: 3,
            spaceBetween: 15,
            },
            992: {
            slidesPerView: maxProductShow,
            spaceBetween: 15,
            },
        },
        });
    });
    }

let realityreference = new Swiper(".block__category--main-swiper", {
  slidesPerView: 2,
  spaceBetween: 20,
  loop: true,
  navigation: {
    nextEl: ".realityreference_next_btn",
    prevEl: ".realityreference_perv_btn",
  },
  breakpoints: {
    310: {
      slidesPerView: 1,
      spaceBetween: 0,
    },
    600: {
      slidesPerView: 1,
      spaceBetween: 0,
    },
    992: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 2,
      spaceBetween: 20
    }
  }
});

});
// Collection Filter Grid
  document.querySelectorAll('.view-mode__button').forEach(btn => {
    btn.addEventListener('click', () => {
      const mode = btn.dataset.viewMode;
      const grid = document.getElementById('product-grid');
      document.querySelectorAll('.view-mode__button').forEach(b =>
        b.classList.remove('view-mode-active')
      );
      btn.classList.add('view-mode-active');
      grid.classList.forEach(c => {
        if (c.startsWith('grid--') && c.endsWith('-col-desktop')) {
          grid.classList.remove(c);
        }
      });
      grid.classList.add(`grid--${mode}-col-desktop`);
    });
  });

document.addEventListener('DOMContentLoaded', initReadMore);
document.addEventListener('shopify:section:load', initReadMore);

function initReadMore() {
  document
    .querySelectorAll('a[data-read-more-trigger]')
    .forEach(function (triggerEl) {

      // prevent multiple bindings on section reload
      if (triggerEl.dataset.readmoreBound === 'true') return;
      triggerEl.dataset.readmoreBound = 'true';

      triggerEl.addEventListener('click', function (e) {
        e.preventDefault();

        const trigger = this.getAttribute('data-read-more-trigger');

        // IMPORTANT: mobile wrapper
        const mobileWrapper = this.closest('.description-mains');
        if (!mobileWrapper) return;

        const shortDesc = mobileWrapper.querySelector('.short-description');
        const longDesc = mobileWrapper.querySelector('.long-description');

        if (!shortDesc || !longDesc) return;

        if (trigger === 'read-more') {
          shortDesc.style.display = 'none';
          longDesc.style.display = 'flex';
        }

        if (trigger === 'read-less') {
          longDesc.style.display = 'none';
          shortDesc.style.display = '-webkit-box';
        }
      });
    });
}

document.querySelector('.open-ring-chart')?.addEventListener('click', function (e) {
  e.preventDefault();
  document.getElementById('ringSizeModal').classList.add('active');
  document.body.classList.add('overflow-hidden');
});

document.querySelector('.ring-size-close')?.addEventListener('click', function () {
  document.getElementById('ringSizeModal').classList.remove('active');
  document.body.classList.remove('overflow-hidden');
});

window.addEventListener('click', function (e) {
  const modal = document.getElementById('ringSizeModal');

  if (e.target === modal) {
    modal.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }
});

function syncEngravingValue() {

  // All visible engraving inputs
  const engravingInputs = document.querySelectorAll('[id^="engraving-text-"]');

  engravingInputs.forEach((engravingInput) => {

    // Get dynamic suffix
    const dynamicId = engravingInput.id.replace('engraving-text-', '');

    // Find matching hidden input
    const hiddenEngravingInput = document.querySelector(
      `#Custom-engraving-${dynamicId}`
    );

    if (!hiddenEngravingInput) return;

    // Initial sync
    hiddenEngravingInput.value = engravingInput.value;

    // Remove duplicate listeners
    engravingInput.oninput = () => {
      hiddenEngravingInput.value = engravingInput.value;

      console.log('Updated Hidden Value:', hiddenEngravingInput.value);
    };
  });
}

// Initial load
syncEngravingValue();

// Re-sync after variant/select change
document.addEventListener('change', (e) => {
  if (
    e.target.matches('select') ||
    e.target.matches('input[type="radio"]')
  ) {
    setTimeout(() => {
      syncEngravingValue();
    }, 300);
  }
});
